import React from 'react'
import { Byline, BylineSection } from '../../../components/common/byline/Byline'
import { StatusArchivedGrey } from '../../../components/common/status/Status'
import Tooltip from '../../../components/common/tooltip/Tooltip'
import { formatDateAndTimeShort } from '../../../utils/dateHelpers'
import { isZeroVersion } from '../../../utils/version'
import { Trans } from '@lingui/macro'
import { dayjsFromNow } from '../../../../../shared/dayjs'
import { Box } from 'front-end/src/components'
import IconDoc from '../../../components/common/icon/IconDoc'

type Props = {
  resourcesCount: number
  publishedDate?: string | null
  updatedDate?: string | null
  version: string
  isArchived?: boolean
}

export const PathwayByline = ({
  resourcesCount,
  publishedDate,
  updatedDate,
  version,
  isArchived = false
}: Props) => {
  const showVersion = !isZeroVersion(version)
  return (
    <>
      <Byline>
        <IconDoc mr="8px" /> {resourcesCount} Resources
        {isArchived && <StatusArchivedGrey ml="4px" />}
      </Byline>

      <Byline>
        {publishedDate && (
          <BylineSection>
            <Tooltip text={formatDateAndTimeShort(publishedDate)}>
              <Trans>Published</Trans> {dayjsFromNow(publishedDate)}
            </Tooltip>
          </BylineSection>
        )}
        <BylineSection showDot={showVersion}>
          {updatedDate && (
            <Tooltip text={formatDateAndTimeShort(updatedDate)}>
              <Trans>Updated</Trans> {dayjsFromNow(updatedDate)}
            </Tooltip>
          )}
        </BylineSection>
        {showVersion && (
          <Box whiteSpace="nowrap" data-test="VersionInfo">
            <Trans>Version</Trans> {version}
          </Box>
        )}
      </Byline>
    </>
  )
}
